// extracted by mini-css-extract-plugin
module.exports = {"bockPage":"styles_bockPage__3r8TK","notBlock":"styles_notBlock__ERAtd","wrapper":"styles_wrapper__ar_fT","title":"styles_title__3gCjv"};